import React from "react";
import styles from './onboarding.module.css';

export default function NameInput({ name, setName }) {

    const onChange = (e) => {
        setName(e.target.value);
    }

    return (
        <>
            <div></div> {/* Empty div for centering like other screens */}
            <div className={styles.flexDiv} style={{ gap: "3.75rem" }}>
                <h1 className={styles.onboardingGreeting}>Welcome Trailblazer!</h1>
                <div>
                    <label style={{ marginBottom: "0.4rem" }}>What do your friends call you?</label>
                    <input id="nickname" className={`${styles.textInput} ${styles.skinnyInput}`} type="text"
                        value={name} onChange={onChange} />
                </div>
            </div>
        </>
    );
}
